import styled from "@emotion/styled";

export const GreyTextWrapper = styled.span`
  /* font-weight: 600;
  letter-spacing: 0.6px; */
`;

export const DefaultWrapper = styled.span``;
